export default __webpack_public_path__ + "static/media/record.eccbc167.png";